export enum MenuType {
    LOADING,
    DEFAULT,
    DROPDOWN_LOGO,
    VERTICAL
}
